__turbopack_context__.v({
  "deviceFrame": "Video-module-scss-module__zEwgAa__deviceFrame",
  "foreground": "Video-module-scss-module__zEwgAa__foreground",
  "iframe": "Video-module-scss-module__zEwgAa__iframe",
  "inlinePlayer": "Video-module-scss-module__zEwgAa__inlinePlayer",
  "playButton": "Video-module-scss-module__zEwgAa__playButton",
  "stack-module-0": "Video-module-scss-module__zEwgAa__stack-module-0",
  "stack-module-1": "Video-module-scss-module__zEwgAa__stack-module-1",
  "stack-module-10": "Video-module-scss-module__zEwgAa__stack-module-10",
  "stack-module-11": "Video-module-scss-module__zEwgAa__stack-module-11",
  "stack-module-12": "Video-module-scss-module__zEwgAa__stack-module-12",
  "stack-module-13": "Video-module-scss-module__zEwgAa__stack-module-13",
  "stack-module-14": "Video-module-scss-module__zEwgAa__stack-module-14",
  "stack-module-15": "Video-module-scss-module__zEwgAa__stack-module-15",
  "stack-module-16": "Video-module-scss-module__zEwgAa__stack-module-16",
  "stack-module-17": "Video-module-scss-module__zEwgAa__stack-module-17",
  "stack-module-18": "Video-module-scss-module__zEwgAa__stack-module-18",
  "stack-module-19": "Video-module-scss-module__zEwgAa__stack-module-19",
  "stack-module-2": "Video-module-scss-module__zEwgAa__stack-module-2",
  "stack-module-20": "Video-module-scss-module__zEwgAa__stack-module-20",
  "stack-module-3": "Video-module-scss-module__zEwgAa__stack-module-3",
  "stack-module-4": "Video-module-scss-module__zEwgAa__stack-module-4",
  "stack-module-5": "Video-module-scss-module__zEwgAa__stack-module-5",
  "stack-module-6": "Video-module-scss-module__zEwgAa__stack-module-6",
  "stack-module-7": "Video-module-scss-module__zEwgAa__stack-module-7",
  "stack-module-8": "Video-module-scss-module__zEwgAa__stack-module-8",
  "stack-module-9": "Video-module-scss-module__zEwgAa__stack-module-9",
  "thumbnail": "Video-module-scss-module__zEwgAa__thumbnail",
  "thumbnailWrapper": "Video-module-scss-module__zEwgAa__thumbnailWrapper",
  "video": "Video-module-scss-module__zEwgAa__video",
  "wrapper": "Video-module-scss-module__zEwgAa__wrapper",
  "z-base": "Video-module-scss-module__zEwgAa__z-base",
  "z-content": "Video-module-scss-module__zEwgAa__z-content",
  "z-footer": "Video-module-scss-module__zEwgAa__z-footer",
  "z-header": "Video-module-scss-module__zEwgAa__z-header",
  "z-hero": "Video-module-scss-module__zEwgAa__z-hero",
  "z-logo": "Video-module-scss-module__zEwgAa__z-logo",
  "z-logo-effect": "Video-module-scss-module__zEwgAa__z-logo-effect",
  "z-navigation": "Video-module-scss-module__zEwgAa__z-navigation",
  "z-sub": "Video-module-scss-module__zEwgAa__z-sub",
});
